export class DemographicGovtQuestions {
  constructor(sQuestionId: number , sAnswerFlag: boolean ) {
    this.sAnswerFlag = sAnswerFlag;
    this.sQuestionId = sQuestionId;
  }
  sQuestionType: string;
  sAnswerFlag: boolean;
  sQuestionId : number;
  sEthnicityType = "";
  sGender = "";
  sRace = "";
  sDemograhicInfoProvidedDate = "";
  sApplicationSignedDate = "";
}
